<template>
  <button
    class="text-button"
    :class="{ active }"
    @click="$emit('click')">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.text-button {
  // ボタンのデフォルトスタイルをリセット
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  appearance: none;
  outline: none;

  display: flex;
  align-items: center;
  color: $grey05;
  font-size: 1rem;
  cursor: pointer;

  &.active {
    color: $l-blue;
  }
}
</style>